import "./ArchiveProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ArchiveTitleSection from "./sections/ArchiveTitleSection"
import ShopContent from "./sections/ShopContent"
import Footer from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <Header />
      <ArchiveTitleSection />
      <ShopContent />
      <Footer />
    </div>
  )
}
